import { render, staticRenderFns } from "./imageSetting.vue?vue&type=template&id=6445434f&scoped=true&"
import script from "./imageSetting.vue?vue&type=script&lang=js&"
export * from "./imageSetting.vue?vue&type=script&lang=js&"
import style0 from "./imageSetting.vue?vue&type=style&index=0&id=6445434f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445434f",
  null
  
)

export default component.exports